import * as React from 'react';

import { Stack } from '@mui/material';

import { Offer } from '../../../graphql/API';
import Step from './Step';

type StepperProps = {
  activeStep: number;
  offer?: Offer;
};

const LIST = ['Select a product', 'Checkout'];

const Stepper: React.FC<StepperProps> = ({ activeStep }) => {
  return (
    <Stack direction='row' spacing={1}>
      {LIST.map((x, i) => (
        <Step key={i} title={x} active={activeStep === i} />
      ))}
    </Stack>
  );
};

export default Stepper;
